import React from "react";
import { Alert, Modal } from "react-bootstrap";
import ForgotPassword from "../../../ForgotPassword";
import { useLocation, useHistory } from "react-router-dom";
import GoogleReCAPTCHA from "../../../../../_components/GoogleReCAPTCHA";
import Input from "../../../../../_components/LoadingInput";
import LoginButton from "../../../components/LoginButton";
import { useOnLogin } from "../../hooks/useOnLogin";
import RegisterButton from "../../../components/RegisterButton";

//import WhatsAppButton from "../../../AppViews/Footer/WhatsAppButton";

export default (props) => {
  const emailRef = React.useRef(null);
  const location = useLocation();
  const history = useHistory();
  const { loading, alertText, showAlert, onLogin } = useOnLogin();
  const handleOnLogin = () => {
    onLogin(data, increaseWrongAttempts);
  };
  function onEnter(e) {
    if (e.key === "Enter") {
      handleOnLogin();
    }
  }
  const increaseWrongAttempts = () => {
    setWrongAttempts(wrongAttempts + 1);
  };
  function goToRegister() {
    history.push({
      pathname: "/register",
      search: location.search,
    });
  }
  function onChange(e) {
    const { name: key, value } = e.target;
    const newData = { ...data };
    newData[key] = value;
    setData(newData);
  }

  const [data, setData] = React.useState({});
  const [enableLoginButton, setEnableLoginButton] = React.useState(false);
  const [modalAppDevelop, setModalAppDevelop] = React.useState(false);
  const [wrongAttempts, setWrongAttempts] = React.useState(0);
  return (
    <div className="col-md-5 col-xs-12 p-2 ">
      <form onSubmit={handleOnLogin}>
        <Input
          label="Email"
          autoFocus
          ref={emailRef}
          data-cy-test="#auth-login-input-email"
          placeholder="Informe aqui o e-mail de acesso"
          id="auth-login-input-email"
          name="email"
          value={data.email}
          onChange={onChange}
          onKeyDown={onEnter}
          loading={loading}
        />
        <Input
          label="Senha de acesso"
          type="password"
          data-cy-test="#auth-login-input-password"
          id="auth-login-input-password"
          name="password"
          value={data.password}
          onChange={onChange}
          onKeyDown={onEnter}
          placeholder="Informe aqui a senha"
          loading={loading}
        />
        <Alert
          data-cy-test="#login-fail-alert"
          key={"danger"}
          variant={"danger"}
          className={showAlert ? "d-block" : "d-none"}
        >
          {alertText}
        </Alert>

        <GoogleReCAPTCHA onChange={setEnableLoginButton} />

        {wrongAttempts >= 3 ? (
          <ForgotPassword componentType={true} email={data.email} />
        ) : (
          <React.Fragment />
        )}

        <LoginButton
          loading={!enableLoginButton || loading}
          disabled={!enableLoginButton || loading}
          data-cy-test="#auth-login-button-submit"
          onClick={handleOnLogin}
        >
          {loading ? (
            <span>
              Autenticando ... <i class="fas fa-spinner fa-pulse"></i>
            </span>
          ) : (
            <span>Fazer Login</span>
          )}
        </LoginButton>
      </form>

      {wrongAttempts >= 3 ? (
        <React.Fragment />
      ) : (
        <ForgotPassword email={data.email} />
      )}

      <p className="lead">Ainda não possui conta no Easygestor Online?</p>
      <RegisterButton onClick={goToRegister}>
        <span>Quero criar minha conta</span>
      </RegisterButton>
      <div>
        <p className="lead py-3 m-0">
          <strong>Baixe o aplicativo</strong>
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddintTop: "10px",
          }}
        >
          <div>
            <a
              href="https://play.google.com/store/apps/details?id=com.easygestor.mobile&hl=pt&gl=BR"
              target="_blank"
            >
              <img
                style={{
                  width: 140,
                }}
                src="https://lh3.googleusercontent.com/q1k2l5CwMV31JdDXcpN4Ey7O43PxnjAuZBTmcHEwQxVuv_2wCE2gAAQMWxwNUC2FYEOnYgFPOpw6kmHJWuEGeIBLTj9CuxcOEeU8UXyzWJq4NJM3lg=s0"
                alt=""
              />
            </a>
          </div>
          <div>
            <img
              onClick={() => setModalAppDevelop(true)}
              style={{
                width: 130,
                cursor: "pointer",
              }}
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt=""
            />
          </div>
        </div>
        <Modal
          onHide={() => setModalAppDevelop(false)}
          show={modalAppDevelop}
          className="pt-0 mt-0"
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <h2>Aplicativo Disponível EM BREVE!</h2>
            <p>
              Nosso aplicativo está em construção mas estamos prontos para
              começar.
            </p>
            <p>
              Avisaremos quando estiver pronto para baixar. Siga-nos nas Redes
              sociais para não perder a novidades.
            </p>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Auth/Login/components/form/index.jsx